var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "ResourceCards",
    {
      attrs: {
        disabled: _vm.isCardDisabled,
        footerPadding: "px-0",
        cardClass: " fullWidthCardRes makeHeightAuto",
      },
    },
    [
      _c(
        "div",
        { staticClass: "flex flex-col w-full p-4 pb-0" },
        [
          _c(
            "div",
            { staticClass: "flex flex-row gap-2 mb-4 justify-between" },
            [
              !_vm.isManagerSuspended && !_vm.isEmailUnconfirmed
                ? _c("Badge", {
                    staticClass: "text-badge capitalize",
                    attrs: {
                      color: _vm.BadgeColor.ACTIVE,
                      styleClasses: "h-auto py-0.5 px-2",
                      value: "Active",
                    },
                  })
                : _vm._e(),
              _vm.isManagerSuspended
                ? _c("Badge", {
                    attrs: {
                      styleClasses: "h-auto py-0.5 px-2",
                      color: _vm.BadgeColor.WARNING,
                      value: _vm.managerSuspendedText,
                    },
                  })
                : _vm._e(),
              _vm.isEmailUnconfirmed && !_vm.isManagerSuspended
                ? _c("Badge", {
                    attrs: {
                      styleClasses: "h-auto py-0.5 px-2",
                      color: _vm.BadgeColor.WARNING,
                      value: _vm.emailStatusText,
                    },
                  })
                : _vm._e(),
              _c("div", { staticClass: "flex flex-row gap-2 items-start" }, [
                _vm.ableToLike
                  ? _c(
                      "button",
                      {
                        on: {
                          click: _vm.handleLikeContractor,
                          mouseover: function ($event) {
                            _vm.isHoveredLike = true
                          },
                          mouseout: function ($event) {
                            _vm.isHoveredLike = false
                          },
                        },
                      },
                      [
                        !_vm.isHoveredLike
                          ? _c("LikeIcon", { staticClass: "h-4 w-4" })
                          : _vm._e(),
                        _vm.isHoveredLike
                          ? _c("UnlikeIcon", { staticClass: "h-4 w-4" })
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.favoriteContractor
                  ? _c(
                      "button",
                      { on: { click: _vm.handleUnlikeContractor } },
                      [_c("UnlikeIcon", { staticClass: "h-4 w-4" })],
                      1
                    )
                  : _vm._e(),
                !_vm.isEmailUnconfirmed
                  ? _c(
                      "div",
                      {
                        staticClass: "cursor-pointer",
                        on: {
                          mouseover: function ($event) {
                            _vm.isHoveredChat = true
                          },
                          mouseout: function ($event) {
                            _vm.isHoveredChat = false
                          },
                          click: function ($event) {
                            return _vm.$emit("message", _vm.contractorUserId)
                          },
                        },
                      },
                      [
                        !_vm.isHoveredChat
                          ? _c("ChatIcon", { staticClass: "h-4 w-4" })
                          : _vm._e(),
                        _vm.isHoveredChat
                          ? _c("ChatIconHover", { staticClass: "h-4 w-4" })
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "flex w-full justify-center h-fit" },
            [
              _c(
                "RouterLink",
                { attrs: { to: _vm.contractorDetailsLink } },
                [
                  _c("ResourceAvatar", {
                    staticClass: "cursor-pointer text-primary-600",
                    attrs: {
                      image: _vm.contractorAvatar,
                      initial: _vm.contractorInitials,
                      available: _vm.userAvailable,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "flex flex-row items-center justify-center pt-2" },
            [
              _c("RouterLink", { attrs: { to: _vm.contractorDetailsLink } }, [
                _c(
                  "span",
                  {
                    staticClass:
                      "font-normal text-lg text-default-500 hover:text-primary-500 flex flex-row blueText items-center cursor-pointer gap-2",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex flex-row items-center justify-flex-start text-center minHeightNames",
                      },
                      [_vm._v(_vm._s(_vm.contractorFullName))]
                    ),
                    _c(
                      "div",
                      { staticClass: "flag-wrapper" },
                      [
                        _vm.country
                          ? _c("country-flag", {
                              staticClass: "country-flag",
                              attrs: { country: _vm.country, size: "small" },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass:
                "flex flex-row justify-center text-default-500 text-base font-normal customLineH items-center text-center",
            },
            [
              _c("p", { staticClass: "minHeightName" }, [
                _vm._v(" " + _vm._s(_vm.job)),
              ]),
            ]
          ),
          _c(
            "div",
            { staticClass: "flex flex-row justify-center items-center" },
            [
              _c("p", { staticClass: "text-sm font-normal grayColor mr-2" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.contractorTag.name ? _vm.contractorTag.name : "n/a"
                    ) +
                    " "
                ),
              ]),
              _vm.isEmployeeTagShown
                ? _c("EmployeeTag", {
                    attrs: {
                      fullName: _vm.contractorFullName,
                      initials: _vm.contractorInitials,
                      avatar: _vm.avatar,
                      defaultTagHidden: true,
                      appliedTag: _vm.appliedTag,
                      contractorId: _vm.contractorId,
                      userUpdatedDate: _vm.userUpdatedDate,
                    },
                    on: {
                      tagUpdated: function ($event) {
                        return _vm.$emit("refetch")
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "md:flex md:flex-wrap w-full" },
            [
              _c("div", { staticClass: "flex customGrow w-full" }, [
                _c(
                  "div",
                  { staticClass: "overflow-hidden items-center flex-1" },
                  [_vm._t("primaryListItem")],
                  2
                ),
              ]),
              _vm._t("rating"),
            ],
            2
          ),
          this.projects !== null
            ? _c("ActionSection", {
                attrs: {
                  isContractor: "true",
                  companyId: _vm.companyId,
                  contractorId: _vm.contractorId,
                  resourceHeight: "resourceActionHeight",
                  actionObject: _vm.getActionSectionValues,
                  currentUser: _vm.currentUser,
                  manager: _vm.contractor,
                  contractor: _vm.contractor,
                  parentStyle: "customHeightSkillRate",
                  onActivateManager: _vm.onActivateManager,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "rightSection",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "flex flex-col items-center w-full",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "projects-value flex flex-col" },
                                [
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(_vm.contractorMinRate) +
                                        _vm._s(_vm.contractorMaxRate)
                                    ),
                                  ]),
                                  _vm.contractorMinRate && _vm.contractorMaxRate
                                    ? _c("p", [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.contractorRateUnit) +
                                            " "
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              ),
                              _c("div", { staticClass: "projects-name" }, [
                                _vm._v("Rate"),
                              ]),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  1119248139
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass:
            "flex flex-col w-full items-center bg-white border-t border-gray-200 mt-1 adjustFlexWidth",
        },
        [
          _c(
            "div",
            {
              staticClass:
                "flex gap-1 w-full skills-footer items-start items-center px-4 pb-4",
            },
            [
              _vm._v(" Skills: "),
              _vm.skills.length > 0
                ? _c(
                    "div",
                    { staticClass: "flex flex-row gap-1 items-center" },
                    [
                      _vm._l(_vm.skills.slice(0, 3), function (skill) {
                        return _c(
                          "div",
                          { key: skill.skill.name, staticClass: "skills-chip" },
                          [_vm._v(" " + _vm._s(skill.skill.name) + " ")]
                        )
                      }),
                      _vm.skills.length > 3
                        ? _c("div", [
                            _c("div", { staticClass: "skills-chip-plus" }, [
                              _vm._v("+" + _vm._s(_vm.skills.length - 3)),
                            ]),
                          ])
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
              _vm.skills.length === 0 || _vm.skills === undefined
                ? _c("div", [_vm._v("n/a")])
                : _vm._e(),
            ]
          ),
        ]
      ),
      [
        _vm._t("badges", null, { belongsToCompany: _vm.belongsToCompany }),
        _c(
          "div",
          {
            staticClass:
              "flex justify-center flex-col items-center w-full px-4",
          },
          [
            _c(
              "div",
              { staticClass: "flex items-center w-full flex-col customGrow" },
              [
                _vm._t("actions", null, {
                  processing: _vm.processing,
                  belongsToCompany: _vm.belongsToCompany,
                  handleRequestCompanyContractor:
                    _vm.handleRequestCompanyContractor,
                }),
                _c("ResendInvitationPlaceholder", {
                  staticClass: "w-full customGrow",
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ setInvitationSentStatus }) {
                        return [
                          _vm.isEmailUnconfirmed
                            ? _c("ContractorResendInvitation", {
                                attrs: {
                                  companyId: _vm.companyId,
                                  contractorId: _vm.contractorId,
                                  invitedByUserId: _vm.currentUserId,
                                  givenName: _vm.givenName,
                                  familyName: _vm.familyName,
                                },
                                on: {
                                  invitationResent: function ($event) {
                                    return setInvitationSentStatus()
                                  },
                                },
                              })
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              2
            ),
            _c(
              "div",
              { staticClass: "flex items-center customGro w-full" },
              [
                _vm.allowAddProject
                  ? _c("AddContractorToProject", {
                      staticClass: "ml-4",
                      attrs: {
                        variant: "linkButton",
                        buttonSize: "no",
                        currentUserRole: _vm.currentUserRole,
                        companyId: _vm.companyId,
                        contractorId: _vm.contractorId,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]
        ),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }